module.exports = __webpack_public_path__ + "static/media/15.07e60f94.jpg";